import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GiftIcon } from "@jti/brand-icons/gift";
import { HandCoinsIcon } from "@jti/brand-icons/hand-coins";
import { PackageIcon } from "@jti/brand-icons/package";
import { Card, useTranslations } from "@jti/ui";
import styles from "./PloomClubBenefitsBanner.module.scss";
const benefits = [
    {
        icon: PackageIcon,
        textKey: "auth.register.success_page.benefits_banner.free_shipping",
        testId: "packageIcon",
    },
    { icon: GiftIcon, textKey: "auth.register.success_page.benefits_banner.special_offers", testId: "giftIcon" },
    {
        icon: HandCoinsIcon,
        textKey: "auth.register.success_page.benefits_banner.exclusive_rewards",
        testId: "handCoinsIcon",
    },
];
export const PloomClubBenefitsBanner = () => {
    const { __ } = useTranslations();
    return (_jsx(Card, { variant: "variant4", title: __("auth.register.success_page.benefits_banner.title"), description: __("auth.register.success_page.benefits_banner.description"), className: styles.container, titleClassName: styles.title, children: _jsx("div", { className: styles.benefitsContainer, children: benefits.map(({ icon: Icon, textKey, testId }) => (_jsxs("div", { className: styles.benefitBlock, "data-testid": "benefitBlock", children: [_jsx("span", { "data-testid": testId, children: _jsx(Icon, { className: styles.benefitIcon }) }), _jsx("p", { className: styles.benefitText, children: __(textKey) })] }, textKey))) }) }));
};
